import { useSelector, useDispatch } from 'react-redux';
import Chart from "react-google-charts";
import React from 'react';

function IndiaMap(){
    let totalTests ='';
    const StateData = useSelector(state => state.InfoCardData.FullData); 
                            
    let chartData = [];
        if (StateData !== undefined){
                const columns = [
                    { type: 'string', label: 'Date' },
                    { type: 'number', label: 'Cases' },
                    ]
                    let rows = [];         
                        StateData.forEach(record => {  
                                rows.push([record.state, record.confirmed])
                        })
        chartData =  [columns, ...rows]
                }
    return(
        StateData !== undefined ?
        <div class="chartBox1">  
        <h3><b><center style={{color:"grey"}}>India Map</center></b> </h3>
        {chartData != undefined && chartData.length > 0 ?
                        <Chart
                                                chartType="GeoChart"
                                                loader={<div style={{color:'grey'}}><center>Loading Chart</center></div>}
                                                data={chartData}
                                                options={{
                                                region: 'IN', 
                                                domain: 'AS',
                                                displayMode: 'auto',
                                                resolution: 'provinces',
                                                colors: ['red'],
                                                backgroundColor: '#001b35',
                                                datalessRegionColor: '#001b35',
                                        // defaultColor: '#f5f5f5',
                                                }}
                                                mapsApiKey="AIzaSyBVFnnKYTVrJHp2nr7ddBiLw298AGjY-6k"
                                                rootProps={{ 'data-testid': '4' }}
                        />: 
                        <center><p class="LoaderMsg">Please wait, Loading............</p></center>    
                      }
        </div>  
 :
  ""
    )
}
export default IndiaMap